webpackJsonp([259716189039662],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var projectElements = {
		images: [{
			"src": "Routine/1",
			"orientation": "landscape"
		}, {
			"src": "Routine/2",
			"orientation": "landscape"
		}, {
			"src": "Routine/3",
			"orientation": "landscape"
		}, {
			"src": "Routine/4",
			"orientation": "landscape"
		}, {
			"src": "Routine/5",
			"orientation": "landscape"
		}, {
			"src": "Routine/6",
			"orientation": "landscape"
		}, {
			"src": "Routine/7",
			"orientation": "landscape"
		}, {
			"src": "Routine/8",
			"orientation": "landscape"
		}, {
			"src": "Routine/9",
			"orientation": "landscape"
		}, {
			"src": "Routine/10",
			"orientation": "landscape"
		}, {
			"src": "Routine/11",
			"orientation": "landscape"
		}, {
			"src": "Routine/12",
			"orientation": "landscape"
		}, {
			"src": "Routine/13",
			"orientation": "landscape"
		}, {
			"src": "Routine/14",
			"orientation": "landscape"
		}, {
			"src": "Routine/15",
			"orientation": "landscape"
		}]
	};
	
	var Paper = function (_React$Component) {
		_inherits(Paper, _React$Component);
	
		function Paper() {
			_classCallCheck(this, Paper);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Paper.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Routine des Lebens',
				text: 'F\xFCr ein Monat habe ich meine t\xE4gliche Routine etwas ver\xE4ndert. Ich hab mir vorgenommen jeden Tag nach dem Aufstehen und vor dem Schlafen gehen ein Foto zu machen. Anfangs hat das ganz gut funktioniert, aber nach ein paar Tagen habe ich bereits eine t\xE4gliche Erinnerung gebraucht. Aus diesem kleinen Experiment habe ich gelernt, dass es mehr als nur ein Monat braucht um neue Gewohnheiten und Routinen zu entwicklen.',
				images: projectElements.images });
		};
	
		return Paper;
	}(_react2.default.Component);
	
	exports.default = Paper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-routine-js-e2c4ddf1fa92ecbfda66.js